// extracted by mini-css-extract-plugin
export default {"previousNext":"PreviousNext_previousNext__FbZVo","previous":"PreviousNext_previous__oQixo","next":"PreviousNext_next__ClaKA"};